<div class="container">
  <div class="text-center">
    <h2>
      <strong class="mainHeading slide-in-left">Text Translations</strong>
    </h2>
  </div>

  <div class="row slide-up">
    <!-- Buttons -->
    <div
      class="col-lg-9 col-md-9 col-sm-12 toolbar d-flex align-items-center gap-2"
    >
      <button
        class="btn btn-primary"
        ngbTooltip="Create City"
        tooltipClass="custom-tooltip"
        (click)="openTranslateModal(content)"
      >
        <span><i class="bi bi-plus"></i></span> Create
      </button>
      <button
        class="btn btn-success"
        (click)="exportToExcel()"
        ngbTooltip="Export to excel"
      >
        <span><i class="bi bi-box-arrow-up me-2"></i></span> Export
      </button>
    </div>
  </div>

  <div class="card shadow-lg p-3 mt-1 slide-up">
    <div class="d-flex justify-content-between align-items-center flex-wrap mb-3">
      <h2 class="mb-0">Text Translation List</h2>
      <div class="col-lg-3 col-md-4 col-sm-12 mt-2 mt-md-0">
        <input
          type="text"
          class="form-control search"
          placeholder="Search"
        />
      </div>
    </div>
  
    <div class="table-responsive">
      <table class="table table-bordered table-striped mx-auto">
        <thead class="table-light">
          <tr class="text-center">
            <th>Title</th>
            <th>English Text</th>
            <th>Arabic Text</th>
            <th>Key Word</th>
            <th>Text Type</th>
            <th>Remarks</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of pagedData" class="text-center">
            <td>{{ row.title }}</td>
            <td>{{ row.description }}</td>
            <td>{{ row.ar_Description }}</td>
            <td>{{ row.notificationKey }}</td>
            <td>{{ row.dataContent }}</td>
            <td>{{ row.remarks }}</td>
            <td class="text-center">
              <i
                class="bi bi-pencil-square text-primary me-2"
                style="cursor: pointer"
                title="Edit"
              ></i>
              <i
                class="bi bi-trash text-danger"
                style="cursor: pointer"
                title="Delete"
              ></i>
            </td>
          </tr>
  
          <tr *ngIf="pagedData.length === 0">
            <td colspan="7" class="text-center">
              <app-no-data-found></app-no-data-found>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  
    <!-- Pagination (optional if needed) -->
    <div *ngIf="pagedData.length > 0" class="d-flex justify-content-between align-items-center mt-3 px-2">
      <div>
        <label class="me-2">Entries per page:</label>
        <select
          class="form-select d-inline-block w-auto"
          [(ngModel)]="pageSize"
          (change)="onPageChange(1)"
        >
          <option *ngFor="let size of pageSizes" [value]="size">
            {{ size }}
          </option>
        </select>
      </div>
  
      <ngb-pagination
        [collectionSize]="pagedData.length"
        [(page)]="currentPage"
        [pageSize]="pageSize"
        (pageChange)="onPageChange($event)"
        [maxSize]="3"
        [rotate]="true"
        [ellipses]="true"
        [boundaryLinks]="true"
      ></ngb-pagination>
  
      <div class="text-muted mb-3 ms-3">
        <strong>
          Showing {{ (currentPage - 1) * pageSize + 1 }} to
          {{
            currentPage * pageSize > pagedData.length
              ? pagedData.length
              : currentPage * pageSize
          }}
          of {{ pagedData.length }} entries
        </strong>
      </div>
    </div>
  </div>
  
</div>

<ng-template #content let-modal>
  <div class="modal-header custom-modal-header">
    <h2 class="modal-title mt-2">
      {{ isEditMode ? "Edit Translation" : "Create Translation" }}
    </h2>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="translationForm">
      <div class="row mb-3">
        <div class="col-md-6">
          <label>Title</label>
          <input
            type="text"
            class="form-control"
            formControlName="title"
            [ngClass]="{
              'invalid-field':
                translationForm.controls['title'].invalid &&
                translationForm.controls['title'].touched
            }"
          />
        </div>
        <div class="col-md-6">
          <label>English Text</label>
          <input
            type="text"
            class="form-control"
            formControlName="englishText"
            [ngClass]="{
              'invalid-field':
                translationForm.controls['englishText'].invalid &&
                translationForm.controls['englishText'].touched
            }"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-6">
          <label>Arabic Text</label>
          <input
            type="text"
            class="form-control"
            formControlName="arabicText"
            [ngClass]="{
              'invalid-field':
                translationForm.controls['arabicText'].invalid &&
                translationForm.controls['arabicText'].touched
            }"
          />
        </div>
        <div class="col-md-6">
          <label>Keyword</label>
          <input
            type="text"
            class="form-control"
            formControlName="keyword"
            [ngClass]="{
              'invalid-field':
                translationForm.controls['keyword'].invalid &&
                translationForm.controls['keyword'].touched
            }"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-6">
          <label>Text Type</label>
          <input
            type="text"
            class="form-control"
            formControlName="textType"
            rows="4"
            [ngClass]="{
              'invalid-field':
                translationForm.controls['textType'].invalid &&
                translationForm.controls['textType'].touched
            }"
          />
        </div>
        <div class="col-md-6">
          <label>Remarks</label>
          <textarea
            type="text"
            class="form-control"
            formControlName="remarks"
            rows="4"
            [ngClass]="{
              'invalid-field':
                translationForm.controls['remarks'].invalid &&
                translationForm.controls['remarks'].touched
            }"
          ></textarea>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button
      class="btn btn-primary"
      *ngIf="!isEditMode"
      (click)="createTranslation()"
    >
      Save
    </button>
    <button class="btn btn-primary" *ngIf="isEditMode" (click)="update()">
      Update
    </button>
    <button class="btn btn-secondary" (click)="modal.dismiss('cancel')">
      Cancel
    </button>
  </div>
</ng-template>

<ng-template #deleteModal let-modal>
    <div class="modal-header custom-modal-header">
      <h3 class="modal-title mt-3">Confirm Deletion</h3>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modal.dismiss()"
      ></button>
    </div>
    <div class="modal-body">
      <p>
        Are you sure you want to delete the title?
      </p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-danger">
        Delete
      </button>
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">
        Cancel
      </button>
    </div>
  </ng-template>
